<template>
  <section class="myhome-con mgt10 mgb10 mgl10 mgr10">
    <div class="tit-type1-box">
      <h1 class="tit-type1">청구 정보</h1>
      <div>
      </div>
    </div>
    <table class="tb-row mgt20">
      <colgroup>
        <col style="width:20%;"/>
        <col style="width:auto;"/>
        <col style="width:20%;"/>
        <col style="width:auto;"/>
      </colgroup>
      <tbody>
      <tr>
        <th>이용월</th>
        <td class="last" colspan="3">
          {{ $cmmn.date.getYmKrFormat(svcUscrgMngDl.stlmCycleVal) }}
        </td>
      </tr>
      <tr v-if="stlmRqstOrderDl">
        <th>결제상태</th>
        <td>
          {{ stlmRqstOrderDl.stlmStnm }}
        </td>
        <th>결제금액</th>
        <td class="last">
          {{ $cmmn.number.addComma(stlmRqstOrderDl.gdsAmt - stlmRqstOrderDl.dscntAmt) }} 원
        </td>
      </tr>
      </tbody>
    </table>
    <div class="tit-type1-box mgt20">
      <h1 class="tit-type1">청구서</h1>
      <div>
      </div>
    </div>
    <table class="tb-row mgt20">
      <colgroup>
        <col style="width:20%;"/>
        <col style="width:20%;"/>
        <col style="width:auto;"/>
        <col style="width:100px;"/>
      </colgroup>
      <tbody>
      <tr>
        <th colspan="2">이용금액 (+)</th>
        <td style="border-right: 0;">
          {{ svcUscrgMngDl.gdsNm }} - {{ svcUscrgMngDl.gdsDpNm }}
        </td>
        <td class="last __right">
          {{ $cmmn.number.addComma(svcUscrgMngDl.useAmt) }} 원
        </td>
      </tr>
      <tr>
        <th rowspan="2">할인금액 (-)</th>
        <th>합계</th>
        <td colspan="2" class="last __right">
          {{ $cmmn.number.addComma(svcUscrgMngDl.dscntAmt) }} 원
        </td>
      </tr>
      <tr v-if="svcUscrgDscntDls.length > 0">
        <th>상세</th>
        <td colspan="2" class="last __right">
          <div v-for="svcUscrgDscntDl in svcUscrgDscntDls"
               :key="'svcUscrgDscntDl' + svcUscrgDscntDl.svcUscrgDscntSn"
               style="font-size: 12px;">
            {{ getSvcUscrgDscntDlCn(svcUscrgDscntDl) }}
          </div>
        </td>
      </tr>
      <tr v-if="svcUscrgDscntDls.length == 0">
        <th>상세</th>
        <td colspan="2" class="last __right">
          <span class="mgl10" style="font-size: 12px;">적용된 할인정책이 없습니다.</span>
        </td>
      </tr>
      <tr>
        <th colspan="2">청구금액 (=)</th>
        <td colspan="2" class="last __right">
          {{ $cmmn.number.addComma(svcUscrgMngDl.useAmt - svcUscrgMngDl.dscntAmt) }} 원
        </td>
      </tr>
      <tr v-if="svcUscrgMngDl.rqstDcsnAt == 'Y'">
        <th colspan="2">거래명세서</th>
        <td colspan="2" class="last __right">
          <btn :txt="'출력'"
               :color="'white'"
               :size="'ssmall'"
               @click="btnDlngDtstm_click()"/>
        </td>
      </tr>
      </tbody>
    </table>
    <template v-if="stlmPrcsDls.length > 0">
      <div class="tit-type1-box mgt20">
        <h1 class="tit-type1">결제 처리 내역</h1>
        <div>
        </div>
      </div>
      <table class="tb-col mgt20">
        <colgroup>
          <col style="width: 160px;">
          <col style="width: 60px;">
          <col style="width: auto;">
          <col style="width: 130px;">
          <col style="width: 90px;">
        </colgroup>
        <thead>
        <tr>
          <th>일시</th>
          <th>구분</th>
          <th>수단</th>
          <th>금액</th>
          <th class="last">결제영수증</th>
        </tr>
        </thead>
        <tbody>
        <tr
            v-for="(stlmPrcsDl) in stlmPrcsDls"
            :key="'stlmPrcsDl' + stlmPrcsDl.stlmPrcsSn">
          <td>{{ $cmmn.date.getYmdhmsFormat(stlmPrcsDl.stlmPrcsDt) }}</td>
          <td>{{ stlmPrcsDl.stlmPrcsSenm }}</td>
          <td>{{ stlmPrcsDl.stlmPrcsMnnm }}</td>
          <td class="__right">
            {{ $cmmn.number.addComma(stlmPrcsDl.stlmPrcsAmt) }} 원
          </td>
          <td>
            <btn v-if="stlmPrcsDl.pgcoUseAt == 'Y'"
                 :txt="'출력'"
                 :color="'white'"
                 :size="'ssmall'"
                 @click="btnRcpt_click(stlmPrcsDl)"/>
          </td>
        </tr>
        </tbody>
      </table>
    </template>
  </section>
  <receipt ref="receiptRef" />
</template>

<script setup>
import {defineProps, onMounted, ref} from 'vue';
import {getStore, getUtils} from "@/utils/import";
import Receipt from "@/components/receipt.vue";
import DlngDtstm from "@/components/dlng-dtstm.vue";

const {$axios, $cmmn, $popup, $alert} = getUtils();
const {$loading} = getStore();

/*const emits = defineEmits(['close', 'compt']);*/

const props = defineProps({
  svcUscrgMngSn: {
    type: Number,
    required: true
  },
});

const svcUscrgMngDl = ref({});
const getSvcUscrgMngDl = async () => {
  const params = {
    svcUscrgMngSn: props.svcUscrgMngSn
  };
  const {data} = await $axios.get('/api/svc/svc-uscrg-mng-dl?' + $cmmn.txt.createQueryStr(params));
  svcUscrgMngDl.value = data;
};

const fcltyInfo = ref({});
const getFcltyByFcltySn = async () => {
  const {data} = await $axios.get('/api/fclty/by-fclty-sn', {params: {fcltySn: svcUscrgMngDl.value.fcltySn}});
  fcltyInfo.value = data;
};

const receiptRef = ref();
const btnRcpt_click = async (stlmPrcsDl) => {
  const params = {
    tid: stlmPrcsDl.pgcoNtlkVal
  }
  receiptRef.value.show(params);
};

const btnDlngDtstm_click = async () => {
  if (svcUscrgMngDl.value.rqstDcsnAt == 'Y') {
    const popupOpts = {
      header: '거래명세서',
    };

    const popupProps = {
      type: '1',
      rqstDcsnDt: svcUscrgMngDl.value.rqstDcsnDt,
      rqstAmt: svcUscrgMngDl.value.useAmt - svcUscrgMngDl.value.dscntAmt,
      fcltyInfo,
      stlmCycleVal: svcUscrgMngDl.value.stlmCycleVal
    };
    $popup.show(DlngDtstm, popupOpts, popupProps);
  } else {
    await $alert('청구 확정 건만 이용 가능합니다.')
  }
};

const svcUscrgDscntDls = ref([]);
const getSvcUscrgDscntDls = async () => {
  const params = {
    svcUscrgMngSn: svcUscrgMngDl.value.svcUscrgMngSn
  }
  const {data} = await $axios.get('/api/svc/svc-uscrg-dscnt-dls', {params});
  svcUscrgDscntDls.value = data;
};

const getSvcUscrgDscntDlCn = ({dscntNm, dscntMtcd, dscntMtnm, dscntVal, dscntAmt}) => {
  let cn = '';
  cn += dscntNm + ' ' + dscntMtnm;
  if (dscntMtcd == '100') {
    cn += ' ( ' + dscntVal + ' % )';
  }
  const dscntAmtTxt = $cmmn.number.addComma(dscntAmt);
  cn += ' : ' + dscntAmtTxt + ' 원';
  return cn;
};

const stlmRqstOrderDl = ref(null);
const getStlmRqstOrderDl = async () => {
  const params = {
    stlmRqstOrderSn: svcUscrgMngDl.value.lastStlmRqstOrderSn,
  }
  const {data} = await $axios.get('/api/stlm/stlm-rqst-order-dl', {params});
  stlmRqstOrderDl.value = data;
};

const stlmPrcsDls = ref([]);
const getStlmPrcsDls = async () => {
  const params = {
    stlmRqstOrderSn: svcUscrgMngDl.value.lastStlmRqstOrderSn,
  }
  const {data} = await $axios.get('/api/stlm/stlm-prcs-dls/by-stlm-rqst-order-sn', {params});
  stlmPrcsDls.value = data.filter(({stlmPrcsFalrAt}) => stlmPrcsFalrAt != 'Y');
};

const init = async () => {
  await getSvcUscrgMngDl();
  await Promise.all([getFcltyByFcltySn(), getSvcUscrgDscntDls()]);

  if (svcUscrgMngDl.value.lastStlmRqstOrderSn) {
    await getStlmRqstOrderDl();
    await getStlmPrcsDls();
  }
};

onMounted(async () => {
  try {
    $loading.on();

    await init();
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
});
</script>

<style scoped>
</style>
